import api from './client';

export interface WarehouseItem {
  id: number;
  name: string;
  unit: string;
  current_stock: number;
  notes: string | null;
}

export const getWarehouseItems = () =>
  api.get<WarehouseItem[]>('/warehouse-items').then(r => r.data);

export const createWarehouseItem = (data: { name: string; unit: string; notes?: string }) =>
  api.post<WarehouseItem>('/warehouse-items', data).then(r => r.data);

export const updateWarehouseItem = (id: number, data: Partial<{ name: string; unit: string; notes: string }>) =>
  api.put<WarehouseItem>(`/warehouse-items/${id}`, data).then(r => r.data);

export const deleteWarehouseItem = (id: number) =>
  api.delete(`/warehouse-items/${id}`);
